import { render, staticRenderFns } from "./LogServiceOrderAttemptsDataTable.vue?vue&type=template&id=f2a4f564&scoped=true"
import script from "./LogServiceOrderAttemptsDataTable.vue?vue&type=script&lang=js"
export * from "./LogServiceOrderAttemptsDataTable.vue?vue&type=script&lang=js"
import style0 from "./LogServiceOrderAttemptsDataTable.vue?vue&type=style&index=0&id=f2a4f564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a4f564",
  null
  
)

export default component.exports